import React from "react";
import { FaFacebook, FaTwitter, FaInstagram, FaLinkedin } from "react-icons/fa";
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-left">
        <h3>¡Síguenos en las redes!</h3>
        <p>Conecta con nosotros para más novedades y sorteos increíbles:</p>
        <div className="social-icons">
          <a href="https://www.facebook.com/profile.php?id=61567288659704" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
          {/* <a href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a> */}
          <a href="https://www.instagram.com/megaloto.express/" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
          {/* <a href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedin /></a> */}
        </div>
      </div>

      <div className="footer-right">
        <h3>Información</h3>
        <p>
          MegaLoto es una plataforma innovadora donde puedes participar en sorteos
          emocionantes y ganar grandes premios. ¡Invita a tus amigos y gana junto a ellos!
        </p>
        <p>
          <a href="https://megaloto-express.web.app/login">Términos y condiciones</a> | <a href="https://wa.me/573133956853?text=Estoy%20interesado%20en%20unirme%20al%20grupo%20de%20ventas%20de%20Megaloto,%20me%20das%20más%20informacion,%20por%20favor">Contacto</a>
        </p>
      </div>
    </footer>
  );
};

export default Footer;
